import { Rating, RatingProps } from '@mui/material';
import { VIEW_MODE } from '../../consts/enums';

type CustomRatingProps = RatingProps & {
  viewMode?: ViewMode,
};

const CustomRating = ({
  viewMode,
  ...muiProps
}: CustomRatingProps): JSX.Element | null => {
  const isReadOnly = viewMode === VIEW_MODE.READ_ONLY;

  const combinedProps = {
    ...muiProps,
    ...(isReadOnly) && {
      style: { cursor: 'default', 'pointer-events': 'none' },
    },
  };

  if (viewMode === VIEW_MODE.HIDDEN) {
    return null;
  }

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Rating { ...combinedProps } />
  );
};

CustomRating.defaultProps = {
  viewMode: VIEW_MODE.READ_ONLY,
};

export default CustomRating;
